import { useEffect, useState } from "react";
import { ref, onValue, off } from "firebase/database";
import { IMessage } from "types/auth";
import useFirebase from "hooks/useFirebase";

const useChatListener = (callId: string | null | undefined) => {
  const [callData, setCallData] = useState<IMessage[]>([]);
  const { database } = useFirebase();

  useEffect(() => {
    if (!database || !callId) return;

    const callRef = ref(database, `messages/${callId}`);

    const unsubscribe = onValue(callRef, (snapshot) => {
      if (snapshot.exists()) {
        let messages = Object.entries(snapshot.val()).map(([id, data]: any) => ({
            id,
            ...data
        }))
        setCallData(messages as IMessage[]);
      } else {
        setCallData([]); // Call might be deleted or unavailable
      }
    });

    return () => off(callRef, "value", unsubscribe); // Cleanup listener
  }, [database, callId]);

  return callData;
};

export default useChatListener;
